import * as React from "react";

import { useProminentError } from "../providers";

export interface ProminentErrorMessageCustomProperties {
  dontRenderMessageAsHtml?: boolean;
  itsOnlyAWarning?: boolean;
}

export enum ProminentErrorMessageBox_PresentationTypes {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS",
}

export type ProminentErrorMessageBox_PresentationType =
  `${ProminentErrorMessageBox_PresentationTypes}`;

export interface ProminentErrorMessageBoxProps {
  message?: string;
  area?: string;
  notForAnyOfTheseAreas?: string[];
  dontRenderMessageAsHtmlWithJquery?: boolean;
  presentationType?: ProminentErrorMessageBox_PresentationType;
}

export const ProminentErrorMessageBox: React.FunctionComponent<
  ProminentErrorMessageBoxProps
> = (props) => {
  const { prominentError, prominentErrorArea } = useProminentError();

  const presentationType = React.useMemo(() => {
    return (
      props.presentationType || ProminentErrorMessageBox_PresentationTypes.ERROR
    );
  }, [props]);

  const message: React.ReactNode | string | null | undefined =
    React.useMemo(() => {
      const childCount = React.Children.count(props.children);
      const childrenAsTheMessage = childCount > 0 ? props.children : null;
      return childrenAsTheMessage || props.message || prominentError;
    }, [props, prominentError]);

  const isThisTheArea = React.useMemo(() => {
    if (prominentErrorArea) {
      const thereIsEitherNoAreaBeingSearchedForOrThisIsIt =
        !props.area || props.area === prominentErrorArea;
      const thisIsExplicitlyToBeAnIgnoredArea =
        !!props.notForAnyOfTheseAreas?.includes(prominentErrorArea);
      return (
        thereIsEitherNoAreaBeingSearchedForOrThisIsIt &&
        !thisIsExplicitlyToBeAnIgnoredArea
      );
    } else {
      if (props.area) {
        return false;
      } else {
        return true;
      }
    }
  }, [props.area, props.notForAnyOfTheseAreas, prominentErrorArea]);

  const onMessageRef: React.LegacyRef<HTMLParagraphElement> = (element) => {
    if (!!props?.dontRenderMessageAsHtmlWithJquery) {
      return;
    }
    (window.require as any)(["jquery"], function ($: any) {
      $(element).html(props.message || prominentError);
    });
  };

  if (!message || !isThisTheArea) {
    return null;
  }
  return (
    <div
      className={`prominent-error-message-box ${presentationType.toLowerCase()}`}
    >
      <div className="left"></div>
      <div className="right">
        <p className="message" ref={onMessageRef}>
          {message}
        </p>
      </div>
    </div>
  );
};
